import { authenticate } from "@/util/auth";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

type FormValues = {
  email: string;
  password: string;
};

const Login = () => {
  const [_isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const navigate = useNavigate();

  async function handleSubmit(values: FormValues) {
    setIsLoading(true);

    try {
      const result = await authenticate(values.email, values.password);
      if (result?.type === "Success") navigate("/");
    } catch (e) {
      const error = e as Error;
      setErrorMessage("Login failed.");
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div
      className="fixed h-full w-full flex flex-col overflow-hidden"
      style={{
        backgroundImage: "url(/bg-login.png)",
        backgroundSize: "cover",
        backgroundPosition: "bottom",
      }}
    >
      <div className="h-full flex flex-col w-full justify-between pb-16 pt-16">
        <div className="flex justify-center">
          <img src="/epsilon-logo.png" alt="Epsilon" className="w-60 z-50" />
        </div>
        <div className="relative flex flex-col items-center mt-8">
          <img
            src="/tuktuk.png"
            alt="Epsilon Tuktuk"
            className="absolute -right-[12%] -translate-y-[70%] w-[72vw] h-auto scale-x-[-1] opacity-95 brightness-90"
          />
          {errorMessage && (
            <div
              className="absolute top-0 bg-red-100 border -translate-y-[100%] border-red-400 text-red-700 px-4 py-2 text-sm rounded mb-4 text-center"
              role="alert"
            >
              <span className="block sm:inline">{errorMessage}</span>
            </div>
          )}
          <LoginForm onSubmit={handleSubmit} />
        </div>
      </div>
    </div>
  );
};

const LoginForm = ({
  onSubmit,
}: {
  onSubmit: (values: FormValues) => void;
}) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleFormSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    onSubmit({ email, password });
  };

  return (
    <form className="w-[70%]" onSubmit={handleFormSubmit}>
      <div className="mb-4">
        <label htmlFor="email" className="block text-[10px] pl-1">
          Email
        </label>
        <input
          type="email"
          id="email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="shadow appearance-none h-12 drop-shadow-lg bg-[#272727] rounded-md w-full py-2 px-4 text-xs leading-tight focus:outline-none focus:shadow-outline"
        />
      </div>
      <div className="mb-6">
        <label htmlFor="password" className="block text-[10px] pl-1">
          Password
        </label>
        <input
          type="password"
          id="password"
          name="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="shadow appearance-none h-12 drop-shadow-lg bg-[#272727] rounded-md w-full py-2 px-4 text-sm mb-3 leading-tight focus:outline-none focus:shadow-outline"
        />
      </div>
      <div className="flex items-center justify-center">
        <button
          type="submit"
          className="bg-brand h-9 w-20 text-sm drop-shadow text-white py-2 px-4 rounded-md focus:outline-none focus:shadow-outline"
        >
          Login
        </button>
      </div>
    </form>
  );
};

export default Login;
